/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  OrganizationDetailDTO,
  OrganizationManagementGetAllOrganizationsParams,
  OrganizationManagementGetOrganizationUsersParams,
  OrganizationOverviewDTOQueryResultDTO,
  OrganizationUserDetailDTOQueryResultDTO,
  PlatformStatisticsDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





/**
 * @summary Get all organizations with pagination and filtering
 */
export const organizationManagementGetAllOrganizations = (
    params?: OrganizationManagementGetAllOrganizationsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationOverviewDTOQueryResultDTO>(
      {url: `/api/site-admin/OrganizationManagement`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getOrganizationManagementGetAllOrganizationsQueryKey = (params?: OrganizationManagementGetAllOrganizationsParams,) => {
    return [`/api/site-admin/OrganizationManagement`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationManagementGetAllOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError = ErrorType<unknown>>(params?: OrganizationManagementGetAllOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationManagementGetAllOrganizationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>> = ({ signal }) => organizationManagementGetAllOrganizations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationManagementGetAllOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>>
export type OrganizationManagementGetAllOrganizationsQueryError = ErrorType<unknown>


export function useOrganizationManagementGetAllOrganizations<TData = Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError = ErrorType<unknown>>(
 params: undefined |  OrganizationManagementGetAllOrganizationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>,
          TError,
          Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationManagementGetAllOrganizations<TData = Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError = ErrorType<unknown>>(
 params?: OrganizationManagementGetAllOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>,
          TError,
          Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationManagementGetAllOrganizations<TData = Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError = ErrorType<unknown>>(
 params?: OrganizationManagementGetAllOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all organizations with pagination and filtering
 */

export function useOrganizationManagementGetAllOrganizations<TData = Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError = ErrorType<unknown>>(
 params?: OrganizationManagementGetAllOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetAllOrganizations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationManagementGetAllOrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get detailed information about a specific organization
 */
export const organizationManagementGetOrganizationDetail = (
    organizationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationDetailDTO>(
      {url: `/api/site-admin/OrganizationManagement/${organizationId}`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationManagementGetOrganizationDetailQueryKey = (organizationId: number,) => {
    return [`/api/site-admin/OrganizationManagement/${organizationId}`] as const;
    }

    
export const getOrganizationManagementGetOrganizationDetailQueryOptions = <TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError = ErrorType<unknown>>(organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationManagementGetOrganizationDetailQueryKey(organizationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>> = ({ signal }) => organizationManagementGetOrganizationDetail(organizationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationManagementGetOrganizationDetailQueryResult = NonNullable<Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>>
export type OrganizationManagementGetOrganizationDetailQueryError = ErrorType<unknown>


export function useOrganizationManagementGetOrganizationDetail<TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError = ErrorType<unknown>>(
 organizationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>,
          TError,
          Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationManagementGetOrganizationDetail<TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>,
          TError,
          Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationManagementGetOrganizationDetail<TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get detailed information about a specific organization
 */

export function useOrganizationManagementGetOrganizationDetail<TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError = ErrorType<unknown>>(
 organizationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationDetail>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationManagementGetOrganizationDetailQueryOptions(organizationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get all users in a specific organization
 */
export const organizationManagementGetOrganizationUsers = (
    organizationId: number,
    params?: OrganizationManagementGetOrganizationUsersParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserDetailDTOQueryResultDTO>(
      {url: `/api/site-admin/OrganizationManagement/${organizationId}/users`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getOrganizationManagementGetOrganizationUsersQueryKey = (organizationId: number,
    params?: OrganizationManagementGetOrganizationUsersParams,) => {
    return [`/api/site-admin/OrganizationManagement/${organizationId}/users`, ...(params ? [params]: [])] as const;
    }

    
export const getOrganizationManagementGetOrganizationUsersQueryOptions = <TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: OrganizationManagementGetOrganizationUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationManagementGetOrganizationUsersQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>> = ({ signal }) => organizationManagementGetOrganizationUsers(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationManagementGetOrganizationUsersQueryResult = NonNullable<Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>>
export type OrganizationManagementGetOrganizationUsersQueryError = ErrorType<unknown>


export function useOrganizationManagementGetOrganizationUsers<TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  OrganizationManagementGetOrganizationUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>,
          TError,
          Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationManagementGetOrganizationUsers<TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationManagementGetOrganizationUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>,
          TError,
          Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationManagementGetOrganizationUsers<TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationManagementGetOrganizationUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all users in a specific organization
 */

export function useOrganizationManagementGetOrganizationUsers<TData = Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: OrganizationManagementGetOrganizationUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetOrganizationUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationManagementGetOrganizationUsersQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get platform statistics and analytics
 */
export const organizationManagementGetPlatformStatistics = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<PlatformStatisticsDTO>(
      {url: `/api/site-admin/OrganizationManagement/statistics`, method: 'GET', signal
    },
      );
    }
  

export const getOrganizationManagementGetPlatformStatisticsQueryKey = () => {
    return [`/api/site-admin/OrganizationManagement/statistics`] as const;
    }

    
export const getOrganizationManagementGetPlatformStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationManagementGetPlatformStatisticsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>> = ({ signal }) => organizationManagementGetPlatformStatistics(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationManagementGetPlatformStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>>
export type OrganizationManagementGetPlatformStatisticsQueryError = ErrorType<unknown>


export function useOrganizationManagementGetPlatformStatistics<TData = Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>,
          TError,
          Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationManagementGetPlatformStatistics<TData = Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>,
          TError,
          Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationManagementGetPlatformStatistics<TData = Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get platform statistics and analytics
 */

export function useOrganizationManagementGetPlatformStatistics<TData = Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationManagementGetPlatformStatistics>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationManagementGetPlatformStatisticsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



